export default "__VITE_ASSET__Ba5QAMeM__"